import React from 'react'
import LoginForm from './LoginForm';
import HeroSlider from './HeroSlider';

const HomeHero = () => {

  const data = [
    {
      image: '../images/home-hero/01.jpg',
      name: 'DressTwin',
    },
    {
      image: '../images/home-hero/02.jpg',
      name: 'DressTwin',
    },
    {
      image: '../images/home-hero/03.jpg',
      name: 'DressTwin',
    },
    {
      image: '../images/home-hero/04.jpg',
      name: 'DressTwin',
    },
    {
      image: '../images/home-hero/07.jpg',
      name: 'DressTwin',
    },
  ];

  return (
    <section className='hero-section'>
      <div className='hero-container'>
        <div className='hero-right'>
          <LoginForm />
        </div>
        <div className='hero-left'>
          <HeroSlider data={data} />
        </div>
      </div>
    </section>
  )
};

export default HomeHero
